
import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from "@angular/material/paginator";

@Injectable()
export class TextCustomization {


    changePaginatorText(paginator: MatPaginatorIntl):void{
        paginator.itemsPerPageLabel="Itens por página:";
        paginator.firstPageLabel = "Primeira página";
        paginator.nextPageLabel = "Próxima página";
        paginator.previousPageLabel = "Página anterior";
        paginator.lastPageLabel  = "Última página";
    }
}